/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  var savedHeaderStyles = [];

  function restoreHeader() {
    savedHeaderStyles.forEach(function(saved) {
      saved.properties.forEach(function(property) {
        if (property.value) {
          saved.element.style.setProperty(property.name, property.value, property.priority);
        } else {
          saved.element.style.removeProperty(property.name);
        }
      });
    });
    savedHeaderStyles = [];
  }

  document.addEventListener('click', function(event) {
    if (!window.matchMedia('(max-width: 999px)').matches || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self') || link.closest('[data-modal], [data-modal-url], [data-action]')) {
      return;
    }

    var destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || !/^https?:$/.test(destination.protocol)) {
      return;
    }
    if (destination.pathname === window.location.pathname && destination.search === window.location.search && (destination.hash || link.getAttribute('href').indexOf('#') !== -1)) {
      return;
    }

    restoreHeader();
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function(element) {
      var position = window.getComputedStyle(element).position;
      if (position !== 'sticky' && position !== '-webkit-sticky') {
        return;
      }

      var top = element.getBoundingClientRect().top;
      savedHeaderStyles.push({
        element: element,
        properties: ['position', 'top', 'bottom'].map(function(name) {
          return { name: name, value: element.style.getPropertyValue(name), priority: element.style.getPropertyPriority(name) };
        })
      });
      element.style.setProperty('position', 'relative', 'important');
      element.style.setProperty('top', '0px', 'important');
      element.style.setProperty('bottom', 'auto', 'important');
      element.style.setProperty('top', (top - element.getBoundingClientRect().top) + 'px', 'important');
    });

    window.setTimeout(function() {
      if (event.defaultPrevented) {
        restoreHeader();
      }
    }, 0);
  });

  window.addEventListener('pageshow', restoreHeader);
  window.addEventListener('resize', restoreHeader);
  window.addEventListener('scroll', restoreHeader, { passive: true });
  document.addEventListener('pointerdown', restoreHeader, true);
  document.addEventListener('touchstart', restoreHeader, { passive: true, capture: true });
  document.addEventListener('keydown', restoreHeader, true);
})();

(function() {
  document.addEventListener('click', function(event) {
    var link = event.target.closest && event.target.closest('.mobile-menu a[href]');
    if (!link) {
      return;
    }

    var menu = document.getElementById('mobile-menu');
    if (!menu || menu.getAttribute('aria-hidden') === 'true') {
      return;
    }

    menu.setAttribute('aria-hidden', 'true');
    menu.style.maxHeight = '';
    menu.querySelectorAll('.mobile-menu__panel.is-open').forEach(function(panel) {
      panel.classList.remove('is-open');
    });

    var toggle = document.querySelector('[aria-controls="mobile-menu"]');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }

    document.documentElement.classList.remove('is-locked');
  }, true);
})();

(function() {
  var html = document.documentElement;
  var cachedWidth = 0;
  var isLocked = false;

  function hasLockClass() {
    return html.classList.contains('is-locked') || html.classList.contains('aa-page-modal-open');
  }

  function cacheScrollbarWidth() {
    if (hasLockClass()) {
      return cachedWidth;
    }

    cachedWidth = Math.max(0, window.innerWidth - html.clientWidth);
    html.style.setProperty('--aa-scrollbar-width', cachedWidth + 'px');
    return cachedWidth;
  }

  function syncLockPadding() {
    var locked = hasLockClass();

    if (locked === isLocked) {
      return;
    }

    isLocked = locked;
    html.classList.toggle('aa-scroll-locked', locked);
    html.style.paddingRight = locked && cachedWidth ? cachedWidth + 'px' : '';

    if (!locked) {
      cacheScrollbarWidth();
    }
  }

  cacheScrollbarWidth();
  window.addEventListener('resize', cacheScrollbarWidth);

  if (window.MutationObserver) {
    new MutationObserver(syncLockPadding).observe(html, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
})();

(function() {
  var startX = 0;
  var startY = 0;

  function isProductGalleryTouch(event) {
    return event.target.closest && event.target.closest('.template-product .product-gallery__carousel');
  }

  document.addEventListener('touchstart', function(event) {
    if (!isProductGalleryTouch(event) || !event.touches || event.touches.length !== 1) {
      return;
    }

    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', function(event) {
    if (!isProductGalleryTouch(event) || !event.touches || event.touches.length !== 1) {
      return;
    }

    var deltaX = Math.abs(event.touches[0].clientX - startX);
    var deltaY = Math.abs(event.touches[0].clientY - startY);

    if (deltaY > 8 && deltaY > deltaX) {
      event.stopImmediatePropagation();
    }
  }, { passive: true, capture: true });
})();

// Sync the product gallery to the pre-selected variant on page load.
// When the first variant is sold out, Shopify pre-selects the first available
// variant server-side but the gallery's data-initial-media-id still points to
// the first variant's image. Firing variant:change after section init corrects this.
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      var sectionEl = document.querySelector('section[data-section-type="product"]');
      if (!sectionEl) return;

      var variantScript = sectionEl.querySelector('script[data-variant]');
      if (!variantScript) return;

      var variant;
      try { variant = JSON.parse(variantScript.textContent); } catch (e) { return; }
      if (!variant || !variant.featured_media) return;

      var galleryEl = sectionEl.querySelector('.product-gallery__carousel');
      if (!galleryEl) return;

      // Only fire if the gallery is currently showing a different image
      var initialMediaId = galleryEl.getAttribute('data-initial-media-id');
      if (String(variant.featured_media.id) === initialMediaId) return;

      sectionEl.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variant: variant }
      }));
    }, 0);
  });
})();

(function() {
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-aa-share]');

    if (!button) {
      return;
    }

    event.preventDefault();

    var title = button.getAttribute('data-share-title') || document.title;
    var url = button.getAttribute('data-share-url') || window.location.href;
    var label = button.querySelector('.aa-share-button__label');
    var originalLabel = label ? label.textContent : '';

    function showCopied() {
      if (!label) {
        return;
      }

      label.textContent = 'Link copied';
      window.setTimeout(function() {
        label.textContent = originalLabel;
      }, 1800);
    }

    if (navigator.share) {
      navigator.share({
        title: title,
        text: title,
        url: url
      }).catch(function() {});
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(showCopied).catch(function() {
        window.prompt('Copy this link', url);
      });
      return;
    }

    window.prompt('Copy this link', url);
  });
})();

(function() {
  document.addEventListener('change', function(event) {
    var target = event.target;
    if (!target || !target.classList || !target.classList.contains('color-swatch__radio')) {
      return;
    }

    var imageUrl = target.getAttribute('data-image-url') || '';
    if (/imagenotavailable|image[_-]not[_-]available/i.test(imageUrl)) {
      target.removeAttribute('data-image-url');
    }

    var productItem = target.closest('.product-item');
    if (productItem && !productItem.querySelector('.product-item__primary-image')) {
      target.removeAttribute('data-image-url');
    }
  }, true);
})();

(function() {
  document.addEventListener('focusin', function(event) {
    var target = event.target.closest('.variant-swatch, .color-swatch, .block-swatch, .variant-swatch__item, .color-swatch__item');

    if (!target) {
      return;
    }

    var list = target.closest('.variant-swatch-list, .color-swatch-list, .block-swatch-list');

    if (!list) {
      return;
    }

    window.requestAnimationFrame(function() {
      window.scrollTo(0, window.scrollY);
      target.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'instant' });
    });
  }, true);
})();

(function() {
  var storageKey = 'aa-collection-layout';

  function readStoredLayout() {
    try {
      var value = window.localStorage.getItem(storageKey);
      if (value === 'list' || value === 'grid') {
        return value;
      }
    } catch (error) {}
    return null;
  }

  function storeLayout(mode) {
    if (mode !== 'list' && mode !== 'grid') {
      return;
    }

    try {
      window.localStorage.setItem(storageKey, mode);
    } catch (error) {}
  }

  function collectionRoot() {
    return document.querySelector('[data-section-type="collection"], [data-section-type="search"]');
  }

  function applyLayout(mode) {
    var root = collectionRoot();
    if (!root) {
      return;
    }

    var settings = {};
    try {
      settings = JSON.parse(root.getAttribute('data-section-settings') || '{}');
    } catch (error) {}

    var gridClasses = settings.gridClasses || '';
    root.querySelectorAll('.product-list--collection > .product-item').forEach(function(item) {
      if (mode === 'list') {
        item.className = 'product-item product-item--list';
      } else {
        item.className = 'product-item product-item--vertical ' + gridClasses;
      }
    });

    root.querySelectorAll('[data-action="change-layout"]').forEach(function(button) {
      button.classList.toggle('is-selected', button.getAttribute('data-layout-mode') === mode);
    });
  }

  function persistLayoutToCart(mode) {
    if ((mode !== 'list' && mode !== 'grid') || !window.routes || !window.routes.cartUrl) {
      return;
    }

    fetch(window.routes.cartUrl + '/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        attributes: {
          collection_layout: mode
        }
      })
    }).catch(function() {});
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-action="change-layout"]');
    if (!button) {
      return;
    }

    storeLayout(button.getAttribute('data-layout-mode'));
  }, true);

  function syncCollectionLayout() {
    var root = collectionRoot();
    if (!root) {
      return;
    }

    var stored = readStoredLayout();
    var renderedList = !!root.querySelector('.product-list--collection > .product-item--list');

    if (!stored) {
      storeLayout('grid');
      if (renderedList) {
        applyLayout('grid');
        persistLayoutToCart('grid');
      }
      return;
    }

    if ((stored === 'list') !== renderedList) {
      applyLayout(stored);
      persistLayoutToCart(stored);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCollectionLayout);
  } else {
    syncCollectionLayout();
  }
})();
